export enum SDKSessionItem {
    UID_TOKEN = 'app-uid-token',
    TOKEN_ID = 'token_id'
}

export enum ApplicationFormState {
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    QUOTED = 'quoted'
}

export enum ApplicationQuestionSetCodes {
    CONSENT = 'send_to_bold_penguin',
    EVANSTON = 'evanston'
}

export enum SessionStorage {
    SESSION_PREFILL_GUID = 'prefillguid'
}
